import i18n from 'i18next';
import { reactI18nextModule } from 'react-i18next';
import intervalPlural from 'i18next-intervalplural-postprocessor';

import { bg, en } from '../translations/';

i18n
  // Chain modules
  .use(intervalPlural)
  .use(reactI18nextModule)
  .init({
    lng: 'en',
    fallbackLng: 'en',
    debug: false,

    // React already does escaping
    interpolation: {
      escapeValue: false,
    },
    react: { wait: true },

    // Note: Best practice is to load that via xhr. Anyways.
    resources: {
      // 'translation' is the default namespace, simply use this one.
      en: { translation: en },
      bg: { translation: bg },
    },
  });

export default i18n;



// WEBPACK FOOTER //
// ./src/core/i18n.js